const RomanEmpire = {
  id: '6',
  name: 'Roman Empire'
};

export default RomanEmpire;
